// react-i18next
import { useTranslation } from "react-i18next";
// Heroicons
import FadeIn from "../FadeIn";
import { Divider } from "@nextui-org/react";
import { MdHealthAndSafety, MdOutlineCleanHands } from "react-icons/md";
import { HiUserGroup } from "react-icons/hi2";
import { LiaUserCogSolid } from "react-icons/lia";

export function PropertyItem({ icon, title, content }) {
  return (
    <div className="flex items-center gap-3  ">
      <div className="bg-primary    p-5 text-white rounded-full">{icon}</div>
      <div>
        <div
          className={`"text-lg md:text-xl font-semibold mb-2  ${
            localStorage.getItem("lng") === "fa"
              ? "text-right"
              : localStorage.getItem("lng") === "en"
              ? "text-left"
              : ""
          }`}
        >
          {title}
        </div>
        <p
          className={` text-sm  leading-normal text-gray-500  ${
            localStorage.getItem("lng") === "fa"
              ? "text-right"
              : localStorage.getItem("lng") === "en"
              ? "text-left"
              : ""
          }`}
        >
          {content}
        </p>
      </div>
    </div>
  );
}

const OurProperty = () => {
  const { t } = useTranslation();

  const items = [
    {
      id: 1,
      title: t("ourpropertyitem1title"),
      content: t("ourpropertyitem1content"),
      icon: <HiUserGroup className="m-auto" size={"70px"} />,
    },
    {
      id: 2,
      title: t("ourpropertyitem2title"),
      content: t("ourpropertyitem2content"),
      icon: <LiaUserCogSolid className="m-auto" size={"70px"} />,
    },
    {
      id: 3,
      title: t("ourpropertyitem4title"),
      content: t("ourpropertyitem4content"),
      icon: <MdHealthAndSafety className="m-auto" size={"70px"} />,
    },
    {
      id: 4,
      title: t("ourpropertyitem3title"),
      content: t("ourpropertyitem3content"),
      icon: <MdOutlineCleanHands className="m-auto" size={"70px"} />,
    },
   
  ];

  return (
    <>
      <section className=" lg:px-14 py-10 md:p-8 w-[85%] lg:w-full 2xl:w-[85%] m-auto mt-10 md:mt-0 lg:space-y-10">
        {/* Title and Content */}
        <div className="flex flex-col w-full  items-center justify-center">
          <h2 className="font-bold text-center text-3xl lg:text-4xl mt-6 lg:mt-0 ">
            {t("ourpropertytitle")}
          </h2>
          <Divider className="bg-red-600 w-72 2xl:w-[25%] h-1  mb-5 mt-4" />
        </div>

        <div className="grid grid-cols-1  gap-8  lg:grid-cols-3 ">
          <div
            className="grid grid-cols-1  gap-y-9 xl:gap-y-0 "
            variants={FadeIn(
              `${localStorage.getItem("dir") === "rtl" ? "left" : "right"}`
            )} // Use your FadeIn function
          >
            {items.slice(0, 2).map((item) => (
              <PropertyItem
                key={item.id}
                title={item.title}
                content={item.content}
                icon={item.icon}
              />
            ))}
          </div>

          <img
            className=" hidden lg:block w-full h-full  rounded-lg"
            src={"/Assets/Images/aa.jpg"}
            alt="brand"
          />

          <div
            className={`grid grid-cols-1  gap-y-9  xl:gap-y-0  ${
              localStorage.getItem("lng") === "fa"
                ? "ltr"
                : localStorage.getItem("lng") === "en"
                ? "rtl"
                : "ltr"
            }`}
            variants={FadeIn(
              `${localStorage.getItem("dir") === "rtl" ? "right" : "left"}`
            )} // Use your FadeIn function
          >
            {items.slice(2, 4).map((item) => (
              <PropertyItem
                key={item.id}
                title={item.title}
                content={item.content}
                icon={item.icon}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default OurProperty;
